(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
    	var roles = ['Administrators', 'DAC Content Administrator', 'DAC Content User'];
        $stateProvider
        .state('dac-content-main.nasrac-provider', {
            parent: 'dac-content-main',
            url: '/nasrac-provider',
            templateUrl: 'app/dac-content/nasrac-provider/nasrac-providers.html',
            controller: 'NasracProviderController',
            controllerAs: 'vm',
            data: {
                authorities: roles,
                pageTitle: 'nasracApp.nasracProvider.home.title'
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('nasracProvider');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('dac-content-main.nasrac-provider.new', {
            parent: 'dac-content-main.nasrac-provider',
            url: '/new',
            data: {
                authorities: roles
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/dac-content/nasrac-provider/nasrac-provider-dialog.html',
                    controller: 'NasracProviderDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                //providerId: null,
                                providerType: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('dac-content-main.nasrac-provider', null, { reload: 'dac-content-main.nasrac-provider' });
                }, function() {
                    $state.go('dac-content-main.nasrac-provider');
                });
            }]
        })
        .state('dac-content-main.nasrac-provider.edit', {
            parent: 'dac-content-main.nasrac-provider',
            url: '/{id}/edit',
            data: {
                authorities: roles
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/dac-content/nasrac-provider/nasrac-provider-dialog.html',
                    controller: 'NasracProviderDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['NasracProvider', function(NasracProvider) {
                            return NasracProvider.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('dac-content-main.nasrac-provider', null, { reload: 'dac-content-main.nasrac-provider' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('dac-content-main.nasrac-provider.delete', {
            parent: 'dac-content-main.nasrac-provider',
            url: '/{id}/delete',
            data: {
                authorities: roles
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/dac-content/nasrac-provider/nasrac-provider-delete-dialog.html',
                    controller: 'NasracProviderDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['NasracProvider', function(NasracProvider) {
                            return NasracProvider.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('dac-content-main.nasrac-provider', null, { reload: 'dac-content-main.nasrac-provider' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
